var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sal-button-container" }, [
    _c(
      "div",
      { staticClass: "v-s-boxes py-3" },
      _vm._l(_vm.currentSalutation, function(salutation, index) {
        return _c("div", { staticClass: "sal-buttons" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addressData.gender,
                expression: "addressData.gender"
              }
            ],
            staticClass: "variation-input-button sal-radio",
            attrs: {
              type: "radio",
              id: salutation.key + _vm.returnAddressType(),
              selected:
                _vm.addressData.gender === salutation.key &&
                _vm.checkGenderCompany(salutation.key)
            },
            domProps: {
              value: salutation.key,
              checked: _vm._q(_vm.addressData.gender, salutation.key)
            },
            on: {
              change: [
                function($event) {
                  return _vm.$set(_vm.addressData, "gender", salutation.key)
                },
                function($event) {
                  return _vm.emitInputEvent($event.target.value)
                }
              ]
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              class:
                "btn btn-outline-primary" +
                { active: _vm.isActive(salutation.key) },
              attrs: { for: salutation.key + _vm.returnAddressType() }
            },
            [_vm._v(_vm._s(salutation.name))]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }